// extracted by mini-css-extract-plugin
module.exports = {"cell":"SettingTermsTermCell_cell__1vJp9"};